import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { followArtist, unfollowArtist } from '../../redux/thunk/followedArtistsThunk';
import { goArtist } from './mixpediaHomeData';
import './MixpediaHome.scss';
import CoverArt from '../CoverArt';

// Full-page artists grid — the cold-start homepage's avatar+Follow card view
// applied to an entity page's artist list ("Artists supporting them",
// "Artists they support", a track's "Supporting Artists"). Opened via the
// external-link icon on those cards (openMixpediaArtistsGrid); the list rides
// in djpal.artistsGridContext so Back/Forward restores it from nav snapshots.
// Unlike the cold-start grid, followed artists stay visible with a
// "Following" pill (click = unfollow) — the list is the page's content, not
// a suggestions queue to burn down.
const MixpediaArtistsGridPage = () => {
    const dispatch = useDispatch();
    const context = useSelector((state) => state.djpal.artistsGridContext);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const followedSet = useSelector((state) => state.followedArtists.followedSet);

    if (!context) return null;
    const { title, subtitle, artists = [] } = context;
    const firstChar = (s) => (s || '?').charAt(0).toUpperCase();

    return (
        <div className="mixpedia-home mixpedia-browse-page">
            <div className="mh-section-header">
                <h3 className="mh-title">
                    {title}
                    {subtitle && <span className="mh-browse-subtitle">{subtitle}</span>}
                </h3>
            </div>
            {artists.length === 0 ? (
                <p className="mh-suggest-done">No artists found.</p>
            ) : (
                <div className="mh-suggest-grid">
                    {artists.map((a) => {
                        const isFollowed = !!followedSet[a.name];
                        return (
                            <div key={a.id || a.name} className="mh-avatar-card" onClick={() => goArtist(dispatch, a.name, a.id, a.artworkUrl, 'artistsGrid')} role="button" tabIndex={0}>
                                {a.artworkUrl ? (
                                    <CoverArt src={a.artworkUrl} size={72} className="mh-avatar" />
                                ) : (
                                    <span className="mh-avatar is-empty">{firstChar(a.name)}</span>
                                )}
                                <span className="mh-avatar-name">{a.name}</span>
                                {isAuthenticated && (
                                    <button
                                        className={`mh-follow-btn${isFollowed ? ' is-following' : ''}`}
                                        title={isFollowed ? 'Unfollow' : 'Follow'}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (isFollowed) {
                                                dispatch(unfollowArtist({ artistName: a.name }));
                                            } else {
                                                dispatch(followArtist({ name: a.name, artworkUrl: a.artworkUrl, id: a.id, from: 'artistsGrid' }));
                                            }
                                        }}
                                    >
                                        {isFollowed ? 'Following' : '+ Follow'}
                                    </button>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default MixpediaArtistsGridPage;
